/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from 'react'

import { graphql, useStaticQuery } from 'gatsby'

export interface SEOProps {
  description: string
  image?: string
  lang?: string
  meta?: [{ name: string; content: string }?]
  titleOverride?: string
  path?: string
  title?: string
}

function SEO({
  description = ``,
  image,
  meta = [],
  titleOverride,
  path = '',
  title,
}: SEOProps) {
  const { site } = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          description
          siteUrl
          title
        }
      }
    }
  `)
  const imageSrc = image
    ? `${site.siteMetadata.siteUrl}${image}`
    : `https://images.ctfassets.net/o6pn4lhbgy5o/3jFU6nFzI4J4VSuoSTQbo3/ac8470104ebf2c850c242a6a6652d212/semi-hero.jpg?fm=jpg`
  const metaDescription = description || site.siteMetadata.description
  const titleTemplate = titleOverride || `${title} | ${site.siteMetadata.title}`

  return (
    <>
      <title>{titleTemplate}</title>
      <meta name="description" content={metaDescription} />
      <meta name="image" content={imageSrc} />
      <meta property="og:title" content={titleTemplate} />
      <meta property="og:url" content={`${site.siteMetadata.siteUrl}${path}`} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:site_name" content={'FORM Kitchens'} />
      <meta property="og:image" content={imageSrc} />
      <meta property="og:type" content="website" />
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:title" content={titleTemplate} />
      <meta name="twitter:description" content={metaDescription} />
      <meta name="twitter:image" content={imageSrc} />
      <meta name="twitter:creator" content={'formremodel'} />
      {meta.map((m) => (
        <meta name={m?.name} content={m?.content} />
      ))}
    </>
  )
}

export default SEO
